import { useFocusEffect, useLocalSearchParams, useRouter } from 'expo-router';
import SuspiciousTransaction from 'features/suspiciousTransaction/screens/SuspiciousTransaction/SuspiciousTransaction';
import React from 'react';

export default function SuspiciousTransactionScreen() {
  const { id } = useLocalSearchParams<{ id: string }>();
  const router = useRouter();

  useFocusEffect(() => {
    if (!id) {
      if (router.canGoBack()) {
        router.back();
      }
      router.navigate('/');
    }
  });

  return <SuspiciousTransaction />;
}
